//Page loading style
const Preloader = () => {
  return (
    <div>
      <h1> loading</h1>
    </div>
  );
};

export default Preloader;
